export default "__VITE_ASSET__DP4cy_yh__"